import { render, staticRenderFns } from "./AccessTokenScopes.vue?vue&type=template&id=ee5df778&"
import script from "./AccessTokenScopes.vue?vue&type=script&lang=ts&"
export * from "./AccessTokenScopes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports